import permissions from "app/permissions";
import { POSTGRADUATE_COURSES, SpecialistServicePath } from "utils/constants";
import NoteAddIcon from "@mui/icons-material/NoteAdd";

import ListPostgraduateCoursesFinalization from "./List";

//permissions
export const resources = {
  isMenu: false,
  icon: <NoteAddIcon />,
  name: SpecialistServicePath + POSTGRADUATE_COURSES + "/all",
  title: "Финализиране на следдипломни курсове",
  list: <ListPostgraduateCoursesFinalization />,
  permission: permissions.canPreviewSpecialistPostgraduateCourses,
};
